<template>
  <div class="mt-5 pb-5">

    <div class="width550 mx-auto mb-5" @click="setCompletedTasks">
      <div class="fs-large font-weight-600 darker pl-2">Set your business configurations.</div>
      <div class="bg-medium w-100 mt-2">
        <div class="progressBar bg-color-3" :style="{'width': completePercent+'%'}"></div>
      </div>
    </div>

    <div v-for="task in tasks">

        <router-link :to="{ name: task.link }">
            <div class="width550 mx-auto panel px-2 border-medium d-flex minHeight127 darker">
                <div class="col-md-2 text-center p-0">
                    <img class="mt-2" :src="'static/images/dashboard/startingTasks/'+task.icon">
                </div>
                <div class="col-md-7 fc-dark">
                    <div class="font-weight-600 fs-large mb-1">{{task.title}}</div>
                    <div>{{task.text}}</div>
                </div>
                <div class="col-md-3 text-center p-0 d-flex flex-colum align-items-center">
                    <div v-if="task.done" class="color-3 w-100">
                        <i class="ico-check color-3 fs-small mx-auto"></i>
                        <span class="fs-small font-weight-600">Completed</span>

                    </div>
                    <div v-else class="w-100">
                        <button class="btn bg-color-1 px-4">Start</button>
                    </div>
                </div>
            </div>
        </router-link>

    </div>

    <div class="text-center dark font-weight-600 mt-3 pointer underline" @click="skipTasksForNow">
        <u>Skip this for now</u>
    </div>


  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
      created: function(){
        this.initCompany().then((value => {
          this.setCompletedTasks();
        }))
        .catch((error) => {
          console.log('initCompany error: '+error);
        });
      },
      data: function() {
        return {
          taskProgress: 0,
          tasks:[
            {
              title:'Add your business profile',
              text:'Set your business configurations and define how your operations will work.',
              icon:'config_img_01.jpg',
              link:'settings',
              done: false
            },
            {
              title:'Resources with 100% of potencial.',
              text:'Create a portfolio full of the best experiences that your company offers.',
              icon:'config_img_02.jpg',
              link:'inventory',
              done: false
            },
            {
              title:'Start your products portfolio.',
              text:'Create a portfolio full of the best experiences that your company offers.',
              icon:'config_img_03.jpg',
              link:'pluralo.product.new',
              done: false
            },
            {
              title:'Build a strong agent team.',
              text:'Invite the best sellers to join your agents team and spread your brand voice everywhere.',
              icon:'config_img_04.jpg',
              link:'people',
              done: false
            }/*,
            {
              title:'Set a workspace that fits your needs.',
              text:'In the settings panel define your business configuration details, and we will customize information for your business needs.',
              icon:'config_img_05.jpg',
              link:'settings',
              done: false
            }*/
          ]
        }
      },
      computed:{
        ...mapGetters([
          'getCompanySettings'
        ]),
        completePercent: function(){
          var tasksObj = this.tasks;
          var totalTasks = tasksObj.length;
          var completedTasks = tasksObj.filter(function(tasksObj){
            return tasksObj.done
          });

          var percent = (completedTasks.length / totalTasks) * 100;

          if(percent == 100){
            this.$emit('forceSkipTasks'); //just for testing
          }

          return percent;
        },
        companySettings: function() {
          //console.log(this.getCompanySettings);
          return this.getCompanySettings;
        },
        updatedCards:function(){
          this.tasks[0].done = this.companySettings.settingProfileEdited;
          this.tasks[1].done = this.companySettings.settingResourceAdd;
          this.tasks[2].done = this.companySettings.settingProductAdded;
          this.tasks[3].done = this.companySettings.settingAgentAdded;
          return true;
        }
      },
      methods:{
        ...mapActions([
            'skipStartingTasks',
            'initCompany'
        ]),
        completeTask: function(task){
          task.done = true;
        },
        setCompletedTasks: function(){
          this.tasks[0].done = this.companySettings.settingProfileEdited;
          this.tasks[1].done = this.companySettings.settingResourceAdd;
          this.tasks[2].done = this.companySettings.settingProductAdded;
          this.tasks[3].done = this.companySettings.settingAgentAdded;
        },
        skipTasksForNow: function(){
            this.skipStartingTasks();
            this.$emit('skipTasksForNow');
        }

      }
    }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .width550{
    width: 550px;
  }

  .minHeight127{
    min-height: 127px;
  }

  .progressBar{
    height: 8px;
    transition: all 300ms ease;
  }

  .taskCircle{
    width: 50px;
    height: 50px;
  }

</style>



// WEBPACK FOOTER //
// StratingTasks.vue?b62eb00c